import { Box, styled } from '@mui/material';

export const TopInstrumentsContainer = styled(Box)(({ theme }) => ({
  width: '28.5%',
  height: '392px',
  display: 'flex',
  flexDirection: 'column',
  order: 2,

  [theme.breakpoints.up('lg')]: {
    order: 3,
  },
}));
